export default __webpack_public_path__ + "static/media/prime_dots.0f7cfbe5.svg";